import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";

# راهنمای سوابق بازرسی (Inspection Records)

این صفحه برای مشاهده و جستجوی سوابق بازرسی‌های کیفی طراحی شده است.

## امکانات جستجو و خروجی
- **هدف بازرسی:** هدف بازرسی‌ها به صورت کد خوانا و قابل فهم نمایش داده می‌شود (شناسه UUID پنهان شده است).
- **جستجوی چند ستونی:** می‌توانید به صورت همزمان در چندین ستون (مانند نوع هدف، نتیجه، یادداشت‌ها) جستجو کنید.
- **خروجی اکسل و PDF:** امکان دریافت خروجی از نتایج جستجو به فرمت‌های Excel و PDF فراهم است.
- **قابلیت پرینت:** می‌توانید مستقیماً گزارش لیست بازرسی‌ها را چاپ کنید.

## مدیریت نتایج
نتایج بازرسی (قبول / رد) با رنگ‌بندی متمایز نمایش داده می‌شوند تا بررسی آن‌ها سریع‌تر انجام شود.

export default function Page({ children }) {
  return <Layout>{children}</Layout>;
}
